export const width = 515;
export const height = 384;
export default __webpack_public_path__ + "static/design-stats-rafiki.f7316c25.svg";